import React from "react";
import { Link, navigate } from "gatsby";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Box, Flex, Text } from "theme-ui";
import Scrollspy from "react-scrollspy";
import { Button, Icon } from "../atoms";
import { colors, typography } from "../../styles/theme";

const StickyBottomMenuV2 = ({ items, cta, customStyles }) => {
  const itemLinks = items?.map((i) => i.hash) || [];

  return (
    <Box sx={{ ...styles.container, ...customStyles }}>
      <Flex sx={styles.inner}>
        <StyledScrollSpy items={itemLinks} currentClassName="is-current">
          {items?.map(({ text, icon, hash, id }, i) => (
            <li key={`sticky-menu-item-${i}`}>
              <Link to={`#${hash}`} id={id}>
                <Icon name={icon} pointerCursor />
                <Text sx={styles.text}>{text}</Text>
              </Link>
            </li>
          ))}
        </StyledScrollSpy>
        {cta && (
          <Button
            id={cta.id}
            variant={cta.variant || "filled"}
            iconName={cta.icon}
            direction="ltr"
            onClick={() => navigate(cta.href)}
          >
            {cta.text}
          </Button>
        )}
      </Flex>
    </Box>
  );
};

const styles = {
  container: {
    p: "1rem 4rem",
    borderRadius: "99999px",
    width: "fit-content",
    minWidth: "56.25rem",
    position: "fixed",
    bottom: "1.5rem",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 98,
    background:
      "linear-gradient(0deg,rgba(255,255,255,0.2),rgba(255,255,255,0.2)),rgba(237,237,237,0.2)",
    backdropFilter: "blur(20px)",
    border: `1px solid ${colors.neutral200}`,
    display: ["none", "none", "none", "block"],
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "3rem",
    flexWrap: "nowrap",
  },
  text: {
    ...typography.textMd500,
    display: "flex",
    alignItems: "center",
  },
};

const StyledScrollSpy = styled(Scrollspy)`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 3rem;
  & > li {
    list-style-type: none;
    padding: 0;
  }

  & > li > a {
    color: ${colors.black};
    text-decoration: none;
    transition: 1s all ease-in-out;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    svg {
      stroke: ${colors.black};
    }
  }

  & > li > a:hover {
    span {
      color: ${colors.primaryMain};
    }
    svg {
      stroke: ${colors.primaryMain};
    }
  }

  & > li.is-current > a {
    span {
      color: ${colors.primaryMain};
    }
    svg {
      stroke: ${colors.primaryMain};
    }
  }
`;

StickyBottomMenuV2.propTypes = {
  items: PropTypes.array,
  cta: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    id: PropTypes.string,
    variant: PropTypes.string,
    icon: PropTypes.string,
  }),
  customStyles: PropTypes.object,
};

StickyBottomMenuV2.defaultProps = {
  variant: "default",
};

export default StickyBottomMenuV2;
